export default __webpack_public_path__ + "static/media/chrome.5c786638.svg";